import React from 'react'
import { CustomerInfoView } from '../code/enums/Enums'
import '../css/customerinfotabcontrol.css'

interface ICustomerInfoTabControlParams {
    selectedView: CustomerInfoView;
    selectedViewChange: Function;
}

export default function CustomerInfoTabControl({ selectedView, selectedViewChange }: ICustomerInfoTabControlParams) {

    function handleTabClick(view: CustomerInfoView) {
        selectedViewChange(view);
    }

    function buildAhref(view: CustomerInfoView, label: string) {
        return (
            <React.Fragment>
                {view === selectedView ?
                    <button className="nav-link active" type="button" role="tab" aria-selected="true"
                        onClick={() => { handleTabClick(view); }}                    
                    >{label}</button>
                    :
                    <button className="nav-link" type="button" role="tab" aria-selected="false"
                        onClick={() => { handleTabClick(view); }}                    
                    >{label}</button>
                }
            </React.Fragment>
        );
    }

    return (
        <ul className="customerinfotabs nav nav-tabs">
            <li className="nav-item">
                {buildAhref(CustomerInfoView.CustomerInfo, "Customer Info")}
            </li>
            <li className="nav-item">
                {buildAhref(CustomerInfoView.PilotInfo, "Pilot Info")}
            </li>
            <li className="nav-item">
                {buildAhref(CustomerInfoView.SubscriptionInfo, "Subscription Info")}
            </li>
            <li className="nav-item">
                {buildAhref(CustomerInfoView.PaymentInfo, "Payment Info")}
            </li>
            <li className="nav-item">
                {buildAhref(CustomerInfoView.Profiles, "Profiles")}
            </li>
            <li className="nav-item">
                {buildAhref(CustomerInfoView.BiddingPlans, "Bidding Plans")}
            </li>
            <li className="nav-item">
                {buildAhref(CustomerInfoView.AwardReport, "Award Report")}
            </li>
        </ul>
    )
}
